





































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'DefaultLayout',

  middleware: [
    'errorRouteGuard',
    'authGuard',
    'hubspot',
    'hotjar',
    'accountSetupGuard'
  ],

  data() {
    return {
      showWarningBar: false
    };
  },

  mounted() {
    this.$intercom.syncUser();
    this.$pushToStateListener.listen();
  },

  computed: {
    ...mapGetters('feature', ['showGrowthCampaigns']),
    ...mapGetters('user', ['accountStatusBarAllowed', 'isClientSession']),
    ...mapGetters('client', ['client']),

    showTopBar() {
      return this.client.isTestClient || this.isClientSession;
    },

    navigationBarClass() {
      if (this.showTopBar && this.showWarningBar) {
        return 'top--100';
      } else if (this.showTopBar || this.showWarningBar) {
        return 'top--50';
      }
    }
  }
});
